const SHOP_WHATSAPP = "212688877277"; 

const formatPrice = (value) =>
  `${Number(value || 0).toLocaleString("fr-MA")} MAD`;

export const buildOrderMessage = (order) => {
  const s = order.shipping || {};
  const lines = [
    "🛍️ *Nouvelle commande Splendrofiy*",
    `N° : ${order.id?.slice(0, 8) ?? "—"}`,
    "",
    "*Client*",
    `${s.firstName ?? ""} ${s.lastName ?? ""}`.trim(),
    `Tél : ${s.phone ?? "—"}`,
    `Adresse : ${s.street ?? ""}, ${s.city ?? ""} ${s.zip ?? ""}`.trim(),
    "",
    "*Articles*",
    ...order.items.map(
      (i) =>
        `• ${i.name}${i.variantLabel ? ` (${i.variantLabel})` : ""} x${i.quantity} — ${formatPrice(i.total)}`
    ),
    "",
    `Sous-total : ${formatPrice(order.subtotal)}`,
    `Livraison : ${order.shippingFee > 0 ? formatPrice(order.shippingFee) : "Gratuite"}`,
    `*Total : ${formatPrice(order.total)}*`,
    `Paiement : ${order.payment ?? "—"}`,
  ];
  return lines.join("\n");
};

export const getWhatsAppUrl = (order) =>
  `https://wa.me/${SHOP_WHATSAPP}?text=${encodeURIComponent(buildOrderMessage(order))}`;